export default "__VITE_ASSET__BSLMnqsR__"